// Who is behind TradePrep and how to reach them. One place, used by the app, the
// emails and the search-engine data. Change a number or a name here and it
// changes everywhere (the Supabase sign-in emails in supabase/templates are
// separate copies: see supabase/templates/README.md).

import type { Site } from './site.ts';

export interface Phone {
  /** How it's dialled in New Zealand. */
  national: string;
  /** How it's dialled from anywhere (and in tel: links). */
  international: string;
  /** Digits for a tel: link. */
  e164: string;
}

export const BUSINESS = {
  /** TradePrep is built by Digitalforge. */
  builtBy: { name: 'Digitalforge', url: 'https://digitalforge.co.nz', host: 'digitalforge.co.nz' },
  /** Support phone numbers (New Zealand mobiles). */
  phones: [
    { national: '022 451 5489', international: '+64 22 451 5489', e164: '+64224515489' },
    { national: '027 341 0168', international: '+64 27 341 0168', e164: '+64273410168' },
  ] as Phone[],
  /** Where TradePrep is run from. */
  address: { street: '25 Medway St', suburb: 'Richmond', city: 'Christchurch', country: 'NZ' },
  /** Standard support hours, in New Zealand time, excluding public holidays. */
  hours: {
    days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
    opens: '09:00',
    closes: '17:00',
    text: 'Monday to Friday, 9am to 5pm New Zealand time (excluding public holidays)',
  },
} as const;

/** "25 Medway St, Richmond, Christchurch" */
export const addressText = (): string => `${BUSINESS.address.street}, ${BUSINESS.address.suburb}, ${BUSINESS.address.city}`;

/** A number the way the site's own visitors dial it: 022 … in New Zealand, +64 22 … from Australia. */
export const phoneText = (p: Phone, site: Site): string => (site.country === 'NZ' ? p.national : p.international);

/** Every support number, as text for a site, e.g. "022 451 5489 or 027 341 0168". */
export const phonesText = (site: Site): string => BUSINESS.phones.map((p) => phoneText(p, site)).join(' or ');

/** "Need a hand? Email … or call …" for emails and plain text. */
export const supportLine = (site: Site): string => `Need a hand? Email ${site.supportEmail} or call ${phonesText(site)}`;
